import topBar from './components/topBar';
import trendingProducts from './components/trendingProducts';
import enableTabbing from './components/enableTabbing';
import toggleCopyright from './components/toggleCopyright';
import cartTorsoTextOverlay from './components/cartTorsoTextOverlay';
import torsoMediaOverlays from './components/torsoMediaOverlays';
import searchTorsoMediaOverlays from './components/searchTorsoMediaOverlays';
import cartImageOverlays from './components/cartImageOverlays';
import preventEmojis from './components/preventEmojis';
import euCheckoutWarning from './components/euCheckoutWarning';
import buyBitsFormTorsoOverlay from './components/buyBitsFormTorsoOverlay';
import buyBitsTorsoSwitcher from './components/buyBitsTorsoSwitcher';

topBar();
trendingProducts();
enableTabbing();
toggleCopyright();
cartTorsoTextOverlay();
buyBitsFormTorsoOverlay();
torsoMediaOverlays();
searchTorsoMediaOverlays();
cartImageOverlays();
preventEmojis();
euCheckoutWarning();
buyBitsTorsoSwitcher();
